(function () {
  var menu = document.querySelector('.news-mobile-menu');
  if (menu) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (!menu.contains(event.target)) menu.open = false;
    });
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { menu.open = false; });
    });
  }
  // Retain Shopify's theme preview when following the news links.
  var params = new URLSearchParams(window.location.search);
  var preview = params.get('preview_theme_id');
  if (preview) document.querySelectorAll('a[href^="/"]').forEach(function (link) {
    var url = new URL(link.getAttribute('href'), window.location.origin);
    url.searchParams.set('preview_theme_id', preview);
    link.href = url.pathname + url.search + url.hash;
  });
  var form = document.querySelector('.news-search');
  if (!form) return;
  var input = form.querySelector('input');
  var cards = Array.from(document.querySelectorAll('[data-news-card]'));
  var count = document.querySelector('.news-count');
  var empty = document.querySelector('.news-empty');
  function search() {
    var query = input.value.trim().toLocaleLowerCase();
    var visible = 0;
    cards.forEach(function (card) {
      var title = card.querySelector('h2');
      var matches = (title ? title.textContent : '').toLocaleLowerCase().includes(query);
      card.hidden = !matches;
      if (matches) visible += 1;
    });
    count.textContent = visible + (visible === 1 ? ' article' : ' articles');
    empty.hidden = visible !== 0;
  }
  form.addEventListener('submit', function (event) { event.preventDefault(); search(); });
  input.addEventListener('input', search);
})();
